import styled from 'styled-components';

export const OvulationContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const LeftOvulationSection = styled.div`
  background-color: ${(props) =>
    props.categoryPage ? '#f0e2f0' : 'rgb(250 208 208 / 17%)'};
  padding: 30px;
  border-radius: 16px 0 0 16px;
  margin: 20px 0 20px 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 720px) {
    margin: 0;
    border-radius: 0;
    text-align: ${(props) => (props.categoryPage ? 'left' : 'center')};
    padding: ${(props) =>
      props.categoryPage ? '20px 18px 10px' : '20px 18px 30px'};
  }
`;

export const RightOvulationSection = styled.div`
  background-color: ${(props) => (props.categoryPage ? '#f0e2f0' : 'fdecec')};
  background-color: #f0e2f0;
  padding: ${(props) =>
    props.categoryPage ? '30px 30px 30px 60px ' : '30px 60px'};
  border-radius: 0 16px 16px 0;
  margin: 20px 30px 20px 0;

  @media (max-width: 720px) {
    margin: 0 0 20px 0;
    border-radius: 0;
    padding: 20px 18px 30px;
  }
`;

export const CalculateHeading = styled.h5`
  font-size: clamp(20px, 3vw, 30px);
  color: hsl(0deg 0% 0% / 87%);
  padding: 10px 0 20px;
`;

export const OvulationContent = styled.p`
  font-size: clamp(13px, 2vw, 15px);
  color: hsl(0deg 0% 0% / 47%);
  line-height: 25px;
  font-weight: 500;
`;

export const LastPeriodHeading = styled.h6`
  font-size: clamp(14px, 2vw, 16px);
  color: hsl(0deg 0% 0% / 87%);
  text-align: center;
  padding: 16px 0 0;
`;

export const IncDecDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
`;

export const Icon = styled.span`
  width: 38px;
  height: 38px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  line-height: 38px;
  text-align: center;
  font-size: 30px;
  color: rgb(0 0 0 / 53%);
  font-weight: 600;
  opacity: ${(props) => (props.opacity ? '0.5' : '')};
  pointer-events: ${(props) => (props.opacity ? 'none' : '')};

  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const Days = styled.span`
  width: 110px;
  height: 38px;
  background-color: #fff;
  border-radius: 8px;
  display: inline-block;
  line-height: 38px;
  text-align: center;
  font-size: 15px;
  color: rgb(0 0 0 / 80%);
  margin: 0 10px;
  font-weight: 500;
`;

export const SelectDate = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  padding: 22px 0px 22px;
  & select {
    padding: 12px 8px;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 500;
    color: #6e6e6e;
    cursor: pointer;
    font-family: 'Montserrat';
  }
  @media (max-width: 720px) {
    padding: 22px 0 10px;
    cursor: auto;
  }
  select option[disabled] {
    display: none;
  }
`;
export const ErrorText = styled.span`
  font-size: clamp(12px, 1.1vw, 14px);
  font-weight: 500;
  color: #ef4e5e;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  padding-bottom: 12px;
  display: inline-block;
  width: 100%;
  text-align: center;

  @media (max-width: 720px) {
    height: ${(props) => (props.preg ? '27.2px' : 'auto')};
  }
`;

export const GridSection = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
`;

export const MenstruationDiv = styled.div`
  @media (max-width: 720px) {
    margin-left: auto;
  }
`;

export const PeriodStartTitle = styled.p`
  font-size: clamp(12px, 2vw, 15px);
  font-weight: 500;
  color: rgb(0 0 0 / 60%);
`;

export const PeriodStart = styled.p`
  font-size: clamp(16px, 2vw, 18px);
  font-weight: 600;
  color: rgb(0 0 0 / 87%);
  padding: 6px 0 0;
`;

export const EstimatedBox = styled.div`
  background-color: #fff;
  padding: 16px;
  border-radius: 6px;
  margin: 16px 0;
`;

export const OvulationDate = styled.p`
  font-size: clamp(18px, 2vw, 22px);
  font-weight: 600;
  padding: 10px 0;
  color: rgb(0 0 0 / 86%);
`;

export const ItalicContent = styled.em`
  font-size: clamp(10px, 2vw, 12px);
  color: rgb(0 0 0 / 56%);
  font-weight: 500;
  text-align: center;
  line-height: 22px;
  display: inline-block;
  padding-bottom: 10px;
`;
